import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6 lg:px-12" data-testid="mentions-legales-page">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white mb-8 transition-colors" data-testid="mentions-back-link">
          <ArrowLeft size={18} />
          Retour
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-4xl font-bold text-white mb-12" data-testid="mentions-title">Mentions L{"é"}gales</h1>

          <div className="space-y-10 text-white/70 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Coordonn{"é"}es</h2>
              <ul className="space-y-2">
                <li><strong className="text-white/90">Raison sociale :</strong> WEBISULA</li>
                <li><strong className="text-white/90">Si{"è"}ge social :</strong> Route des Sanguinaires, Ajaccio</li>
                <li></li>
                <li><strong className="text-white/90">Forme juridique :</strong> Ind{"é"}pendant</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">{"É"}dition du site</h2>
              <ul className="space-y-2">
                <li><strong className="text-white/90">Cr{"é"}ateur du site internet :</strong> WEBISULA</li>
                <li><strong className="text-white/90">Responsable publication :</strong> WEBISULA (personne morale)</li>
                <li><strong className="text-white/90">Contact :</strong> webisula@gmail.com</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">H{"é"}bergement</h2>
              <ul className="space-y-2">
                <li>Le site est h{"é"}berg{"é"} sur les serveurs de <strong className="text-white/90">OVH</strong></li>
                <li>SAS au capital de 10 069 020 {"€"}</li>
                <li>Si{"è"}ge social : 2 rue Kellermann - 59100 Roubaix - France</li>
                <li>RCS Roubaix / Tourcoing 424 761 419 00011</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Contenu {"é"}ditorial</h2>
              <p>
                Le site propose un contenu {"é"}ditorial (guides, actualit{"é"}s) dans un seul but documentaire et {"à"} titre indicatif. 
                Ce contenu doit {"ê"}tre pris comme des {"é"}l{"é"}ments de r{"é"}flexion. Les utilisateurs sont invit{"é"}s par l{"'"}{"é"}diteur {"à"} 
                exploiter ces informations avec un esprit critique et discernement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Liens hypertextes vers des sites tiers</h2>
              <p>
                Le site propose des liens hypertextes pointant vers des sites Internet {"é"}dit{"é"}s par des tiers. 
                La mise en place de ces liens ne signifie pas l{"'"}approbation par l{"'"}{"é"}diteur du contenu des dits sites. 
                L{"'"}{"é"}diteur ne peut pas r{"é"}aliser en permanence un contr{"ô"}le du contenu des dits sites, et ne peut donc garantir : 
                l{"'"}exactitude, la fiabilit{"é"}, la pertinence, la mise {"à"} jour, ou l{"'"}exhaustivit{"é"} de leur contenu ; 
                leur acc{"è"}s et bon fonctionnement technique.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Droits de propri{"é"}t{"é"} intellectuelle</h2>
              <p>
                L{"'"}{"é"}diteur est titulaire de droits concernant certaines donn{"é"}es prot{"é"}g{"é"}es par le Code de la propri{"é"}t{"é"} intellectuelle. 
                Il en est notamment ainsi pour sa ou ses marques, sa charte graphique, sa base de donn{"é"}es. 
                Par cons{"é"}quent, leur exploitation offline ou online, {"à"} titre gratuit ou on{"é"}reux, de tout ou partie de ces donn{"é"}es 
                sans le consentement expresse de l{"'"}{"é"}diteur est interdite.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Disponibilit{"é"} des services</h2>
              <p>
                L{"'"}{"é"}diteur dispose d{"'"}une obligation de moyens en terme d{"'"}accessibilit{"é"} de service et met en place les structures 
                n{"é"}cessaires pour rendre le site accessible 7 jours sur 7 et 24 heures sur 24. N{"é"}anmoins, l{"'"}{"é"}diteur peut suspendre 
                l{"'"}acc{"è"}s sans pr{"é"}avis, notamment pour des raisons de maintenance et de mises {"à"} niveau. L{"'"}{"é"}diteur n{"'"}est en aucun cas 
                responsable des {"é"}ventuels pr{"é"}judices qui peuvent en d{"é"}couler pour l{"'"}utilisateur ou tout tiers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Droit applicable</h2>
              <p>
                Le pr{"é"}sent texte est soumis au droit fran{"ç"}ais. L{"'"}{"é"}diteur se r{"é"}serve le droit d{"'"}en amender {"à"} tout moment 
                les termes, conditions et mentions d{"'"}avertissement.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
